module.exports = __webpack_public_path__ + "media/images/logo-d1f14264.svg";